<template>
  <card header="Energy status items">
    <template v-slot:actions>
      <card-action
        icon="add"
        tooltip="Create a new energy status items configuration"
        @click="onCreate"
      />
    </template>
    <div>
      <v-data-table v-if="models.length" :headers="headers" :items="models" item-key="id"
        class="energy-status-items-table"
        :rows-per-page-items="[5]"
      >
        <template v-slot:items="props">
          <tr :key="props.item.id">
            <td :title="props.item.endpointPath">{{ props.item.endpointPath }}</td>
            <td>{{ props.item.unit }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.toSubscribe ? 'Subscribe' : `Poll (${props.item.pollInterval}ms)` }}</td>
            <td>
              <div class="color-gradient" :style="iconStyle(props.item.colorGradient)" />
            </td>
            <td>
              <div class="energy-status-items-table-actions">
                <v-tooltip bottom class="energy-status-items-table-action">
                  <v-btn slot="activator" @click="onEdit(props.item)" icon flat>
                    <v-icon small>edit</v-icon>
                  </v-btn>
                  <span>{{ 'common.button.edit' | translate }}</span>
                </v-tooltip>
                <v-tooltip bottom class="energy-status-items-table-action">
                  <v-btn slot="activator" @click="onDelete(props.item.id)" icon flat>
                    <v-icon small>delete</v-icon>
                  </v-btn>
                  <span>{{ 'common.button.delete' | translate }}</span>
                </v-tooltip>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div v-else>
        None defined 
      </div>
      <edit-energy-status-item-dialog 
        :show="showDialog"
        :model="modelToEdit" 
        @closed="showDialog = false"
      />
    </div>
  </card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import Card from '../../ui/Card.vue'
import CardAction from '../../ui/CardAction.vue'

import EditEnergyStatusItemDialog from './EditEnergyStatusItemDialog.vue'

import { FunctionDefinitionViewModel } from '../../../store/modules/functionDefinitionEditorUi/models'

import { EnergyStatusItem } from '../../../../../eco-domain-store-modules/src/systemConfiguration/models'
import { Gradients } from '@ecocoach/shared-components/src'

const FunctionDefinitionEditorUi = namespace('functionDefinitionEditorUi')

@Component({
  components: {
    Card,
    CardAction,
    EditEnergyStatusItemDialog,
  },
})
export default class EnergyStatusItemsDetail extends Vue {
  @FunctionDefinitionEditorUi.Getter public functionDefinition: FunctionDefinitionViewModel
  @FunctionDefinitionEditorUi.Getter public actionInProgress: string
  @FunctionDefinitionEditorUi.Mutation public removeFunctionDefinitionEnergyStatusItem: (payload: string) => void

  public showDialog = false
  public modelToEdit: EnergyStatusItem | null = null

  public get models() {
    return this.functionDefinition.energyStatusItems
  }

  public get headers() {
    return [
      {
        text: 'Endpoint path',
        value: 'endpointPath',
        align: 'left',
        width: '25%',
      },
      {
        text: 'Unit',
        value: 'unit',
        align: 'left',
        width: '20%',
      },
      {
        text: 'Type',
        value: 'type',
        align: 'left',
        width: '20%',
      },
      {
        text: 'Subscribe/Poll',
        value: 'toSubscribe',
        align: 'left',
        width: '20%',
      },
      {
        text: 'Color',
        value: 'colorGradient',
        sortable: false,
        width: '5%',
      },
      {
        text: '',
        sortable: false,
        width: '10%',
      },    
    ]
  }

  public iconStyle(colorGradient: string) {
    return Gradients.style(colorGradient, true)
  }

  public onCreate() {
    this.modelToEdit = null
    this.showDialog = true
  }

  public onEdit(model: EnergyStatusItem) {
    this.modelToEdit = model
    this.showDialog = true
  }

  public onDelete(id: string) {
    this.removeFunctionDefinitionEnergyStatusItem(id)
  }
}
</script>
<style lang="scss" scoped>
  .cardbody {
    margin-left: -10px;
  }
  .popUpButton {
    flex: 0;
    padding-left: 10px;
  }
  .field {
    height: 70px;
  }
  .field .label {
    padding-left: 10px;
    overflow: hidden;
    max-height: 40px;
  }
  thead tr {
    border-bottom: 1px solid white!important;
  }
  .energy-status-items-table {
    .energy-status-items-table-actions {
      display: flex;
      justify-content: flex-end;
      .energy-status-items-table-action {
        width: 36px;
      }
    }
  }
  .color-gradient {
    height: 25px;
    width: 25px;
    border-radius: 5px;
  }
</style>
<style lang="css">
.energy-status-items-table .theme--dark.v-table {
  background-color: transparent !important;
  table-layout: fixed;
  width: 100%;
}
.energy-status-items-table .v-datatable__actions {
  background-color: transparent !important;
}
</style>